module.exports = __webpack_public_path__ + "static/media/893ADF73-2213-4C94-97C1-7570AE7A557A.8b4021fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/893ADF73-2213-4C94-97C1-7570AE7A557A.jpg
// module id = 307
// module chunks = 0